import React, { useRef } from "react";
import "./result.css";
import FilterListIcon from "@material-ui/icons/FilterList";
import {
  ResultCard,
  SidebarSlider,
  SidebarComponent,
  Pagination,
} from "../../components";
import { IconButton } from "@material-ui/core";
import { useDataLayerValue } from "../../data-layer";
import { useYoutubeSearch } from "../../hooks/request-handler";
function Result({ show }) {
  const [{ term, page = 1 }, dispatch] = useDataLayerValue();
  const pageNumber = useRef(null);

  const data = useYoutubeSearch(
    `search?part=snippet&maxResults=25&q=${encodeURIComponent(term||sessionStorage.getItem("query"))}${
      page !== 1 && `&pageToken=${page}`
    }`
  );

  const handleVideo = (item) => {
    dispatch({
      type: "SET_VIDEO",
      video: item,
    });
    localStorage.setItem("watchVideo", JSON.stringify(item));
  };
  const handleClick = (click) => {
    if (click === null || click > pageNumber.current) {
      dispatch({
        type: "SET_PAGE",
        page: data?.nextPageToken,
      });
    } else {
      dispatch({
        type: "SET_PAGE",
        page: data?.prevPageToken,
      });
    }
    pageNumber.current = click;
  };
  return (
    <div className="resultPage">
      <div className="resultPage__left">
        {!show ? <SidebarSlider /> : <SidebarComponent />}
      </div>
      <div
        style={{ marginLeft: `${!show ? "227px" : "88px"}` }}
        className="resultPage__right"
      >
        <div className="resultPage__rightHeading">
          <IconButton>
            {" "}
            <FilterListIcon fontSize="large" />
          </IconButton>{" "}
          FILTER
        </div>
        <div className="resultPage__rightArea">
          <div className="resultPage__queryTitle">Showing results for <b><i>{term||sessionStorage.getItem("query")}</i></b></div>
          {data?.items?.map((item) => (
            <ResultCard
              songName={item.snippet.title}
              detail={item}
              videoDetail={handleVideo}
              channelName={item.snippet.channelTitle}
              description={item.snippet.description}
              release={item.snippet.publishedAt}
              id={
                item.id.kind === "youtube#video"
                  ? item.id.videoId
                  : item.id.channelId
              }
              isChannel={item.id.kind === "youtube#channel" ? true : false}
              key={item.id.videoId || item.id.channelId}
              src={item.snippet?.thumbnails.high.url}
            />
          ))}
          {data && (
            <Pagination
              totalNumberOfItem={parseInt(data?.pageInfo?.totalResults)}
              click={handleClick}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Result;
